import { BlockDiagram } from '@cadstrom/cadstrom-shared';
import { useColorScheme } from '@mui/material/styles';

export type BlockDiagramLegendProps = {
	/** Voltage scale of the displayed diagram (from the compiled result). */
	voltageScale: BlockDiagram.VoltageScaleEntry[];
};

/**
 * Voltage legend for a block diagram: one chip per distinct rail voltage,
 * coloured by its rank in the theme's rail palette, hottest first. Styled as a
 * translucent card for overlaying on the diagram canvas; renders nothing when
 * the diagram has no ranked rails.
 */
export function BlockDiagramLegend({ voltageScale }: BlockDiagramLegendProps) {
	const { colorScheme } = useColorScheme();
	if (voltageScale.length === 0) {
		return null;
	}
	const colors = BlockDiagram.blockDiagramColorsByName(colorScheme === 'light' ? 'light' : 'dark');
	return (
		<div className='flex flex-wrap items-center gap-2 rounded-lg border border-gray-a6 bg-gray-2/60 px-2.5 py-1.5 text-xs backdrop-blur-md'>
			<span className='text-gray-a10'>Rails</span>
			{voltageScale.map((entry) => (
				<span key={entry.label} className='flex items-center gap-1'>
					<span className='h-2 w-4 rounded-sm' style={{ backgroundColor: colors[`rail-rank-${entry.rank}`] }} />
					{entry.label}
				</span>
			))}
		</div>
	);
}
